import styled from 'styled-components';

export const Box = styled.div<{ isReviewed: boolean }>`
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};

  &:nth-of-type(${(props) => (props.isReviewed ? 2 : 1)}) {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:not(&:nth-of-type(${(props) => (props.isReviewed ? 2 : 1)})) {
    border-top: none;
  }
`;

export const Header = styled.div`
  display: flex;
  flex: 1;
  padding: 8px 12px;
  border-bottom: 1px solid ${(props) => props.theme.colors['neutral-40']};
  background: ${(props) => props.theme.colors['neutral-20']};

  &:first-of-type {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

export const CompetencyNameWrapper = styled.div`
  display: flex;
  flex: 0.8;
  justify-content: left;
  align-items: baseline;
  gap: 8px;
`;

export const CompetencyName = styled.p`
  display: flex;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const CompetencyWeight = styled.p`
  font-size: 12px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-70']};
`;

export const ActionLabel = styled.p`
  display: flex;
  flex: 0.2;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
`;
